export const AuthActions = {
    SEND_AXIAL_AUTH_DETAILS : "SEND_AXIAL_AUTH_DETAILS",
    SEND_INTERNAL_AUTH_DETAILS : "SEND_INTERNAL_AUTH_DETAILS",
    GET_AXIAL_SESSION_DATA: "GET_AXIAL_SESSION_DATA"
}
